// NEW_FILE_JUSTIFIED: Composite address input for policy application forms — street/city/postal sub-fields; country shown only when addressShowCountry is set
import { Input } from '@/components/ui/input';
import { CountryCombobox } from '@/components/insurance/CountryCombobox';
import type { IAddressFieldProps } from '@/@types/policyFormTemplates';

export function AddressField({
  field,
  value,
  onChange,
  disabled,
  showCountry,
}: IAddressFieldProps) {
  const update = (key: keyof typeof value, val: string) => {
    onChange({ ...value, [key]: val });
  };

  return (
    <div className="space-y-3">
      {field.label && (
        <p className="text-[13px] font-semibold text-zinc-900">
          {field.label}
          {field.required && <span className="text-destructive ml-1">*</span>}
        </p>
      )}
      <div className="grid grid-cols-2 gap-5">
        <Input
          value={value.street}
          onChange={e => update('street', e.target.value)}
          placeholder="Enter street address"
          disabled={disabled}
        />
        <Input
          value={value.city}
          onChange={e => update('city', e.target.value)}
          placeholder="Enter city"
          disabled={disabled}
        />
      </div>
      <div className="grid grid-cols-2 gap-5">
        <Input
          value={value.postalCode}
          onChange={e => update('postalCode', e.target.value)}
          placeholder="Enter postal code"
          disabled={disabled}
        />
        {showCountry ? (
          <CountryCombobox
            value={value.country}
            onChange={val => update('country', val)}
            disabled={disabled}
          />
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}
